import { useEffect, useState } from "react";
import { api } from "../../api";

export function StoreDashboard({ activeStore }) {
  return (
    <div data-testid="store-dashboard">
      <div className="topbar">
        <div>
          <div className="page-title">Store <span className="dim">Dashboard</span></div>
          <div className="page-meta">
            <span className="live-dot">Live</span>
            <span>{activeStore ? `${activeStore.name} · ${activeStore.shop_id}` : "No store selected"}</span>
          </div>
        </div>
      </div>
      {!activeStore ? (
        <div className="alert alert-info"><span>ℹ️</span> Select a store from the sidebar to view its dashboard.</div>
      ) : (
        <div className="stats-grid" style={{ gridTemplateColumns: "repeat(4,1fr)" }}>
          <div className="stat-card"><div className="stat-platform-line" style={{ background: "var(--shopee)" }} /><div className="stat-label">Today's Spend</div><div className="stat-value">RM 820</div><div className="stat-change up">↑ 4% vs yesterday</div></div>
          <div className="stat-card"><div className="stat-platform-line" style={{ background: "var(--green)" }} /><div className="stat-label">GMV (Today)</div><div className="stat-value">RM 6.4k</div><div className="stat-change up">↑ 11% vs yesterday</div></div>
          <div className="stat-card"><div className="stat-platform-line" style={{ background: "var(--accent)" }} /><div className="stat-label">ROAS</div><div className="stat-value">7.8×</div><div className="stat-change up">↑ 0.2× vs yesterday</div></div>
          <div className="stat-card"><div className="stat-platform-line" style={{ background: "var(--blue)" }} /><div className="stat-label">Budget Utilisation</div><div className="stat-value">82%</div><div className="stat-change neutral">RM 820 / RM 1,000</div></div>
        </div>
      )}
    </div>
  );
}

export function Performance() {
  return (
    <div data-testid="performance-page">
      <div className="topbar"><div><div className="page-title">Performance <span className="dim">Analytics</span></div><div className="page-meta"><span className="live-dot">Live · 5 min refresh</span><span>Last 7 days</span></div></div></div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Impressions</div><div className="stat-value">2.4M</div><div className="stat-change up">↑ 8%</div></div>
        <div className="stat-card"><div className="stat-label">Clicks</div><div className="stat-value">84.2k</div><div className="stat-change up">↑ 11%</div></div>
        <div className="stat-card"><div className="stat-label">Orders</div><div className="stat-value">1,842</div><div className="stat-change up">↑ 14%</div></div>
        <div className="stat-card"><div className="stat-label">Conversion Rate</div><div className="stat-value">2.19%</div><div className="stat-change up">↑ 0.3%</div></div>
        <div className="stat-card"><div className="stat-label">Avg. Order Value</div><div className="stat-value">RM 116</div><div className="stat-change down">↓ 2%</div></div>
      </div>
    </div>
  );
}

export function Rules() {
  return (
    <div data-testid="rules-page">
      <div className="topbar"><div><div className="page-title">Rules <span className="dim">Engine</span></div><div className="page-meta">Define, schedule and manage budget automation rules</div></div></div>
      <div className="card"><div className="card-header"><div><div className="card-title">All Rules</div><div className="card-sub">10 active · 2 pending · 1 paused</div></div></div>
        <table><thead><tr><th>Rule</th><th>Platform</th><th>Budget</th><th>Schedule</th><th>Status</th></tr></thead>
          <tbody>
            <tr><td>Nightly Search</td><td><span className="badge b-shopee">🛍️ Shopee</span></td><td style={{ color: "var(--green)", fontFamily: "'JetBrains Mono',monospace" }}>RM 500</td><td style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 11 }}>Daily 00:00</td><td><span className="badge b-active">● Active</span></td></tr>
            <tr><td>GMV Max Sale</td><td><span className="badge b-shopee">🛍️ Shopee</span></td><td style={{ color: "var(--shopee)", fontFamily: "'JetBrains Mono',monospace" }}>RM 1,200</td><td style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 11 }}>Daily 00:00</td><td><span className="badge b-active">● Active</span></td></tr>
            <tr><td>TikTok Weekend</td><td><span className="badge b-tiktok">🎵 TikTok</span></td><td style={{ color: "var(--accent2)", fontFamily: "'JetBrains Mono',monospace" }}>RM 600</td><td style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 11 }}>Sat–Sun 00:00</td><td><span className="badge b-pending">⏳ Pending</span></td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function Approvals() {
  return (
    <div data-testid="approvals-page">
      <div className="topbar"><div><div className="page-title">Approvals <span className="dim">Queue</span></div><div className="page-meta">Rules require admin sign-off before firing</div></div></div>
      <div className="alert alert-warn"><span>⚠️</span><strong>2 rules pending</strong> — they will not fire tonight without your approval.</div>
      {[
        { title: "TikTok Weekend Boost — Spon Max RM600", budget: "RM 600/day", prev: "RM 400/day", client: "Fashion House", by: "Planner 1 · 2 hours ago" },
        { title: "Shopee GMV Max — 6.6 Sale Override RM2,400", budget: "RM 2,400/day", prev: "RM 1,200/day", client: "Athleisure", by: "Planner 1 · 5 hours ago" },
      ].map((a, i) => (
        <div className="appr-card" key={i}>
          <div className="appr-header"><div className="appr-title">{a.title}</div><span className="badge b-pending">⏳ Pending</span></div>
          <div className="appr-meta">Submitted by: {a.by}<br />From: Petaling Jaya, Malaysia · IP: 60.48.xxx.xxx</div>
          <div className="appr-grid">
            <div className="appr-item"><div className="key">Budget</div><div className="val" style={{ color: "var(--accent2)" }}>{a.budget}</div></div>
            <div className="appr-item"><div className="key">Prev</div><div className="val" style={{ color: "var(--muted)" }}>{a.prev}</div></div>
            <div className="appr-item"><div className="key">Client</div><div className="val">{a.client}</div></div>
            <div className="appr-item"><div className="key">Schedule</div><div className="val">Tonight 00:00</div></div>
          </div>
          <div className="appr-actions">
            <button className="btn btn-success">✓ Approve</button>
            <button className="btn btn-danger">✗ Reject</button>
          </div>
        </div>
      ))}
    </div>
  );
}

export function Clients() {
  const [clients, setClients] = useState([]);
  const [stores, setStores] = useState([]);
  useEffect(() => {
    api.get("/clients").then(r => setClients(r.data)).catch(() => {});
    api.get("/stores").then(r => setStores(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="clients-page">
      <div className="topbar"><div><div className="page-title">Clients <span className="dim">& Stores</span></div><div className="page-meta">Connected accounts across all platforms and countries</div></div></div>
      <div className="client-overview">
        {clients.map(c => (
          <div key={c.id} className="co-card">
            <div className="co-header"><div className="co-avatar">{c.avatar}</div><div><div className="co-name">{c.name}</div><div className="co-stores">{stores.filter(s => s.client_id === c.id).length} stores</div></div></div>
            <div className="co-metrics">
              <div className="co-metric"><div className="k">Status</div><div className="v" style={{ color: c.status === "active" ? "var(--green)" : "var(--yellow)", fontSize: 12 }}>● {c.status}</div></div>
              <div className="co-metric"><div className="k">Stores</div><div className="v">{stores.filter(s => s.client_id === c.id).length}</div></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then(r => setLogs(r.data)).catch(() => {}); }, []);
  const color = { login: "li-green", logout: "li-blue", login_failed: "li-red", pin_unlock: "li-green", pin_failed: "li-red", user_created: "li-blue", user_updated: "li-blue", user_deactivated: "li-yellow", password_reset: "li-blue", password_reset_requested: "li-yellow" };
  return (
    <div data-testid="audit-log-page">
      <div className="topbar"><div><div className="page-title">Audit <span className="dim">Log</span></div><div className="page-meta">Tamper-proof history · Who · What · When · Where</div></div></div>
      <div className="card">
        <div className="card-header"><div className="card-title">Activity History</div></div>
        {logs.length === 0 ? <div className="empty">No activity yet.</div> : logs.map(l => (
          <div className="log-row" key={l.id}>
            <div className={`log-indicator ${color[l.action] || "li-blue"}`} />
            <div className="log-content">
              <div className="log-text"><strong>{l.action.replace(/_/g," ")}</strong> {l.meta?.email ? `— ${l.meta.email}` : l.meta?.target ? `— user ${String(l.meta.target).slice(-6)}` : ""}</div>
              <div className="log-detail">{l.ip} · {l.ua?.slice(0, 60)}</div>
            </div>
            <div className="log-time">{new Date(l.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Settings() {
  return (
    <div data-testid="settings-page">
      <div className="topbar"><div><div className="page-title">API <span className="dim">Settings</span></div><div className="page-meta">Platform credentials · Encrypted at rest · Master access only</div></div></div>
      <div className="alert alert-info"><span>🔒</span> AES-256 encrypted. Only visible to Master.</div>
      <div className="grid-2">
        {[["🛍️ Shopee Open Platform","Partner ID","Partner Key"],["🔵 Lazada Open Platform","App Key","App Secret"]].map(([t,a,b]) => (
          <div className="card" style={{ margin: 0 }} key={t}>
            <div className="card-header"><div className="card-title">{t}</div></div>
            <div style={{ padding: 20 }}>
              <div className="form-group"><label>{a}</label><input type="text" placeholder="••••••" /></div>
              <div className="form-group"><label>{b}</label><input type="password" placeholder="••••••••••••••••" /></div>
              <button className="btn btn-primary">Save</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
